"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailFieldLogic = void 0;
var email_fieldtype_1 = require("./email.fieldtype");
Object.defineProperty(exports, "EmailFieldLogic", { enumerable: true, get: function () { return email_fieldtype_1.EmailFieldLogic; } });
